import { Action } from '@ngrx/store';
import { type } from '../../shared';
import { SimpleObjectValue } from '../../shared/models/simple-object';

export const dhlratesActionTypes = {
  ADD: type('[DHLrates] Add'),
  ADD_SUCCESS: type('[DHLrates] Add Success'),
  ADD_FAIL: type('[DHLrates] Add Fail'),
  REMOVE_CLEAR: type('[DHLrates] cleared'),
  ADDRETURN: type('[DHLrates] Add return'),
  ADD_SUCCESS_RETURN: type('[DHLrates] Add return Success'),
  ADD_FAIL_RETURN: type('[DHLrates] Add return Fail'),
  REMOVE_CLEAR_RETURN: type('[DHLrates] return cleared')
};

export class CreateDHLrates implements Action {
  readonly type = dhlratesActionTypes.ADD;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class CreateDHLratesSuccess implements Action {
  readonly type = dhlratesActionTypes.ADD_SUCCESS;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class CreateDHLratesFail implements Action {
  readonly type = dhlratesActionTypes.ADD_FAIL;
  constructor(public payload?: string) {}
}

export class ClearDHLratesFail implements Action {
  readonly type = dhlratesActionTypes.REMOVE_CLEAR;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}
}


export class CreateDHLratesreturn implements Action {
  readonly type = dhlratesActionTypes.ADDRETURN;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class CreateDHLratesSuccessreturn implements Action {
  readonly type = dhlratesActionTypes.ADD_SUCCESS_RETURN;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}

export class CreateDHLratesFailreturn implements Action {
  readonly type = dhlratesActionTypes.ADD_FAIL_RETURN;
  constructor(public payload?: string) {}
}

export class ClearDHLratesFailreturn implements Action {
  readonly type = dhlratesActionTypes.REMOVE_CLEAR_RETURN;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}
}
